import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { EconomyService, ValutaItem } from '../../../services/economy.service';
import { AccountItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
    selector: 'tt-business-co-bank-account',
    templateUrl: './business-co-bank-account.component.html',
    styleUrls: ['./business-co-bank-account.component.css'],
    standalone: false
})
export class BusinessCoBankAccountComponent implements OnInit {
    businessCoNo;

    businessCoBankAccountKeyno;

    public page?: BusinessCoBankAccountGet;

    public selectListCurrencies: ValutaItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private economy: EconomyService, private typeahead: TypeaheadService) {
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
        this.businessCoBankAccountKeyno = this.stateService.getStateParams()['businessco_bankaccount_keyno'];
    }

    private async loadPage() {
        if (!!this.businessCoNo && !!this.businessCoBankAccountKeyno) {
            this.page = (await this.datatask.Post(3355, {
                businessco_no: this.businessCoNo,
                businessco_bankaccount_keyno: this.businessCoBankAccountKeyno
            }))[0];
        }
    }

    private async loadCurrencies() {
        this.selectListCurrencies = await this.economy.getValutas();
    }

    public searchAccountNameOcrs = () => {
        return this.typeahead.lookUpSearchAccounts({
            searchtext: this.page!.account_name_ocr,
            businessco_no: this.page!.businessco_no,
            //onlyaccounttype: 'a' // onlyaccounttype should be added into interface SearchAccountsParams but before that we have to solve following bug issues that appear in CustomerEditComponent and CustProdAccBcsComponent (ODL)?
        });
    }

    public onAccountNameOcrSelected(event?: AccountItem) {
        if (!this.page) return;

        this.page.account_no_ocr = !!event ? '' + event.item_id : '0';
        this.page.account_name_ocr = event?.item_name ?? '';
    }

    public searchAccountNameAgios = () => {
        return this.typeahead.lookUpSearchAccounts({
            searchtext: this.page!.account_name_agio,
            businessco_no: this.page!.businessco_no,
            //onlyaccounttype: 'a' // onlyaccounttype should be added into interface SearchAccountsParams but before that we have to solve following bug issues that appear in CustomerEditComponent and CustProdAccBcsComponent (ODL)?
        });
    }

    public onAccountNameAgioSelected(event?: AccountItem) {
        if (!this.page) return;

        this.page.account_no_agio = !!event ? '' + event.item_id : '0';
        this.page.account_name_agio = event?.item_name ?? '';
    }

    public searchAccountNameDisAgios = () => {
        return this.typeahead.lookUpSearchAccounts({
            searchtext: this.page!.account_name_disagio,
            businessco_no: this.page!.businessco_no,
            //onlyaccounttype: 'a' // onlyaccounttype should be added into interface SearchAccountsParams but before that we have to solve following bug issues that appear in CustomerEditComponent and CustProdAccBcsComponent (ODL)?
        });
    }

    public onAccountNameDisAgioSelected(event?: AccountItem) {
        if (!this.page) return;

        this.page.account_no_disagio = !!event ? '' + event.item_id : '0';
        this.page.account_name_disagio = event?.item_name ?? '';
    }

    public searchAccountNameBankFees = () => {
        return this.typeahead.lookUpSearchAccounts({
            searchtext: this.page!.account_name_bank_fees,
            businessco_no: this.page!.businessco_no,
            //onlyaccounttype: 'a' // onlyaccounttype should be added into interface SearchAccountsParams but before that we have to solve following bug issues that appear in CustomerEditComponent and CustProdAccBcsComponent (ODL)?
        });
    }

    public onAccountNameBankFeeSelected(event?: AccountItem) {
        if (!this.page) return;

        this.page.account_no_bank_fees = !!event ? '' + event.item_id : '0';
        this.page.account_name_bank_fees = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.page) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3356, this.page))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadPage();
        this.loadCurrencies();
    }

    ngOnInit() {
        this.init();
    }
}

interface BusinessCoBankAccountGet {
    businessco_bankaccount_keyno: string;
    businessco_no: string;
    account_no_ocr: string;
    account_name_ocr: string;
    bankaccount: string;
    bankaccount_name: string;
    account_no_agio: string;
    account_name_agio: string;
    account_no_disagio: string;
    account_name_disagio: string;
    account_no_bank_fees: string;
    account_name_bank_fees: string;
    valuta_id: string;
    company_name: string;
    bankreconciliation_start_date: string;
}

// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('businessCoBankAccount', {
//         templateUrl: 'views/components/views/businessCoBankAccount/businessCoBankAccount.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'businessCoBankAccountService', 'economyService', 'typeaheadService', function ($stateParams, stateService, translateService, modalService, businessCoBankAccountService, economyService, typeaheadService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let businessCoNo = $stateParams.businessco_no;
//             let businessCoBankAccountKeyno = $stateParams.businessco_bankaccount_keyno;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 edit: {},
//                 selectListCurrencies: [],
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await businessCoBankAccountService.getEdit({
//                     businessco_no: businessCoNo,
//                     businessco_bankaccount_keyno: businessCoBankAccountKeyno
//                 }))[0];
//             }

//             async function loadCurrencies() {
//                 vm.model.selectListCurrencies = await economyService.listCurrencies();
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//             vm.typeaheadSearch = function (value, id) {
//                 switch (id) {
//                     case 'account_name_ocr':
//                     case 'account_name_agio':
//                     case 'account_name_disagio':
//                     case 'account_name_bank_fees':
//                         vm.model.edit[id] = value;

//                         return typeaheadService.lookUpSearchAccounts({
//                             searchtext: vm.model.edit[id] || '',
//                             businessco_no: vm.model.edit.businessco_no,
//                             onlyaccounttype: 'a'
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//             // #region SELECTED VALUE FUNCTION

//             vm.onTypeaheadSelected = function (item, id) {
//                 switch (id) {
//                     case 'account_name_ocr':
//                         if (item) {
//                             vm.model.edit.account_no_ocr = item?.item_id ?? '0';
//                             vm.model.edit.account_name_ocr = item?.item_name ?? '';
//                         } else {
//                             vm.onTypeaheadClear('account_name_ocr');
//                         }
//                         break;
//                     case 'account_name_agio':
//                         if (item) {
//                             vm.model.edit.account_no_agio = item?.item_id ?? '0';
//                             vm.model.edit.account_name_agio = item?.item_name ?? '';
//                         } else {
//                             vm.onTypeaheadClear('account_name_agio');
//                         }
//                         break;
//                     case 'account_name_disagio':
//                         if (item) {
//                             vm.model.edit.account_no_disagio = item?.item_id ?? '0';
//                             vm.model.edit.account_name_disagio = item?.item_name ?? '';
//                         } else {
//                             vm.onTypeaheadClear('account_name_disagio');
//                         }
//                         break;
//                     case 'account_name_bank_fees':
//                         if (item) {
//                             vm.model.edit.account_no_bank_fees = item?.item_id ?? '0';
//                             vm.model.edit.account_name_bank_fees = item?.item_name ?? '';
//                         } else {
//                             vm.onTypeaheadClear('account_name_bank_fees');
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion SELECTED VALUE FUNCTION

//             // #region CHANGED VALUE FUNCTION

//             vm.onTypeaheadChanged = function (value, item, id) {
//                 switch (id) {
//                     case 'account_name_ocr':
//                         vm.model.edit.account_name_ocr = value;

//                         if (value) {
//                             if (item?.item_id) {
//                                 vm.model.edit.account_no_ocr = item.item_id;
//                             }
//                         } else {
//                             vm.onTypeaheadClear('account_name_ocr');
//                         }
//                         break;
//                     case 'account_name_agio':
//                         vm.model.edit.account_name_agio = value;

//                         if (value) {
//                             if (item?.item_id) {
//                                 vm.model.edit.account_no_agio = item.item_id;
//                             }
//                         } else {
//                             vm.onTypeaheadClear('account_name_agio');
//                         }
//                         break;
//                     case 'account_name_disagio':
//                         vm.model.edit.account_name_disagio = value;

//                         if (value) {
//                             if (item?.item_id) {
//                                 vm.model.edit.account_no_disagio = item.item_id;
//                             }
//                         } else {
//                             vm.onTypeaheadClear('account_name_disagio');
//                         }
//                         break;
//                     case 'account_name_bank_fees':
//                         vm.model.edit.account_name_bank_fees = value;

//                         if (value) {
//                             if (item?.item_id) {
//                                 vm.model.edit.account_no_bank_fees = item.item_id;
//                             }
//                         } else {
//                             vm.onTypeaheadClear('account_name_bank_fees');
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion CHANGED VALUE FUNCTION

//             // #region CLEAR VALUE FUNCTION

//             vm.onTypeaheadClear = function (id) {
//                 switch (id) {
//                     case 'account_name_ocr':
//                         vm.model.edit.account_no_ocr = '0';
//                         vm.model.edit.account_name_ocr = '';
//                         break;
//                     case 'account_name_agio':
//                         vm.model.edit.account_no_agio = '0';
//                         vm.model.edit.account_name_agio = '';
//                         break;
//                     case 'account_name_disagio':
//                         vm.model.edit.account_no_disagio = '0';
//                         vm.model.edit.account_name_disagio = '';
//                         break;
//                     case 'account_name_bank_fees':
//                         vm.model.edit.account_no_bank_fees = '0';
//                         vm.model.edit.account_name_bank_fees = '';
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion CLEAR VALUE FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 businessCoBankAccountService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.lockedSave = false;
//                                 }
//                             }]
//                         });
//                     } else {
//                         vm.model.lockedSave = false;
//                         stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadCurrencies();
//             }

//             // #endregion ON INIT FUNCTION
//         }]
//     });
// })();
